// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export var FigmaStructureImportState;
(function (FigmaStructureImportState) {
    FigmaStructureImportState["failed"] = "Failed";
    FigmaStructureImportState["inProgress"] = "InProgress";
    FigmaStructureImportState["success"] = "Success";
})(FigmaStructureImportState || (FigmaStructureImportState = {}));
export class FigmaStructure {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        this.id = model.id;
        this.sourceId = model.sourceId;
        this.createdAt = model.createdAt;
        this.updatedAt = model.updatedAt;
        this.state = parseImportState(model.importState);
    }
}
function parseImportState(state) {
    switch (state) {
        case "Failed":
            return FigmaStructureImportState.failed;
        case "InProgress":
            return FigmaStructureImportState.inProgress;
        case "Success":
            return FigmaStructureImportState.success;
        default:
            return FigmaStructureImportState.success;
    }
}
